import React from 'react';
import NextJSHead from 'next/head';

const Head = ({ children }: { children: React.ReactNode }) => {
  return <NextJSHead>{children}</NextJSHead>;
};

export default Head;
